import type { FaireProductEntity } from "../../entity_types/product";

export const p_5bqza4p6qs: FaireProductEntity = {
  token: "p_5bqza4p6qs",
  type: "product",
  name: "VW T1 Groovy Orange",
  brandToken: "b_d42s9nfu",
  brandName: "Candylab Toys",
  imageUrl:
    "https://cdn.faire.com/fastly/58335979bd9851f3c5fdb90ab0965a3b60aafdf778086dee491c95ab2755faa0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9c1188c70c41337413035fa5d8575f50c50bc23e27cda0beaee796894493f76e.jpeg",
    "https://cdn.faire.com/fastly/bd0e41b65349ee5cfdac6b7e2439ae425e58158d949c0d3e4e90cc0ca393f53d.jpeg",
    "https://cdn.faire.com/fastly/bebe911e7b9f3c016f2229ca1092325d9dbe2b741fe2d503d39c82d838c77a2a.jpeg",
  ],
  priceDollars: 12.4,
  description:
    "Groovy, dude! A pocket-sized, uniquely cute toy, made of wood and pure nostalgia. \nOur patented Wooden Diecast™ construction is all solid beech, painted with water-based paints, and is fully endorsed by our partners at VW®. \nBright and orange, and right now on its way to the beach. Catch you later, alligator!\n",
  tags: [],
  msrpDollars: 24.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:34:11.411Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
